import { useEffect, useState, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GenericList from './GenericList';
import GenericSearch from './GenericSearch';
import { get_all_donors } from '../api/donor_api';
import '../styles/Beneficiaries.css';
import { getStatusInHebrew } from '../utils/translations';
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';
import Footer from './Footer';

const Donors = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchTerm = searchParams.get('search') || '';
  const searchKeyType = searchParams.get('searchKey') || 'first_name';
  const setSearchTerm = (val) => setSearchParams(prev => { const p = new URLSearchParams(prev); p.set('search', val); return p; }, { replace: true });
  const setSearchKeyType = (val) => setSearchParams(prev => { const p = new URLSearchParams(prev); p.set('searchKey', val); return p; }, { replace: true });

  const { items, loadMore, loading, hasMore } = useInfiniteScroll(get_all_donors, searchTerm, searchKeyType);

  const columns = [
    { key: 'donor_id', label: 'דרכון/ת.ז.' },
    { key: 'first_name', label: 'שם פרטי' },
    { key: 'last_name', label: 'שם משפחה' },
    { key: 'address', label: 'כתובת' },
    { key: 'phone', label: 'פלאפון' },
    { key: 'email', label: 'אימייל' },
    {
      key: 'status',
      label: 'סטטוס',

      render: (item) => getStatusInHebrew(item.status)
    },
  ];

  const handleRowClick = (item) => {
    navigate(`/donors/${item.id}`);
  };

  // const filteredDonors = useMemo(() => {
  //   if (!searchTerm.trim()) return donors; 
  //   return donors.filter(d => {
  //     const field = d[searchKeyType];
  //     if (!field) return false;
  //     return field.toString().toLowerCase().includes(searchTerm.toLowerCase());
  //   });
  // }, [donors, searchTerm, searchKeyType]);
  return (
    <>
      <div className="top-buttons-container">
        {/* כפתור חזרה דף אחורה - עם חץ */}
        <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </button>
        {/* כפתור דף הבית - עם בית */}
        <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
            <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
          </svg>
        </button>
      </div>
      <br />
      <div className="beneficiaries-container">
        <div className="header">
          <h2 className="title">ניהול תורמים</h2>

          <GenericSearch
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            searchKeyType={searchKeyType}
            setSearchKeyType={setSearchKeyType}
            searchFields={[
              { key: 'first_name', label: 'שם פרטי' },
              { key: 'last_name', label: 'שם משפחה' },
              { key: 'donor_id', label: 'דרכון/ת.ז.' },
              { key: 'address', label: 'כתובת' },
              { key: 'phone', label: 'פלאפון ' },
              { key: 'email', label: 'אימייל' },
              { key: 'status', label: 'סטטוס' },
            ]}
          />

          <button className="add-btn" onClick={() => navigate('/add_donor')}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#EF5DA8"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
            הוספת תורם
          </button>
        </div>

        <GenericList
          data={items}
          columns={columns}
          onLoadMore={loadMore}
          hasMore={hasMore}
          loading={loading}
          onRowClick={handleRowClick}
        />
      </div>
    </>
  );

};

export default Donors;

